import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

export type ConfirmColor = 'primary' | 'accent' | 'warn';

export interface ConfirmDialogData {
  title: string;
  message: string;
  confirmText?: string;
  color?: ConfirmColor;
  icon?: string;
  requireReason?: boolean;
  reasonLabel?: string;
  reasons?: Array<{ value: string; label: string }>;
}

@Component({
  selector: 'app-dialog-confirm-contract',
  templateUrl: './dialog-confirm-contract.component.html',
  styleUrls: ['./dialog-confirm-contract.component.scss']
})
export class DialogConfirmContractComponent implements OnInit {
  selectedReason = '';

  constructor(
    public ref: MatDialogRef<DialogConfirmContractComponent, boolean | { confirm: true; reason: string }>,
    @Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData
  ) {}

  ngOnInit(): void {
  }

  onCancel(): void { 
    this.ref.close(false); 
  }

  onConfirm(): void {
    if (this.requiresReason() && !this.selectedReason) {
      return;
    }
    if (this.requiresReason()) {
      this.ref.close({ confirm: true, reason: this.selectedReason });
      return;
    }
    this.ref.close(true);
  }

  requiresReason(): boolean {
    return Boolean(this.data?.requireReason);
  }

}
